module.exports = require("ink");